import React from 'react';
import useLanguageList from '../../../Core/Hooks/HookInitialSetup/useLanguageList';
import useLanguageMonitor from '../../../Core/Hooks/HookInitialSetup/useLanguage';
import { loadEnvironmentUrls } from '../../../Domain/Redux/Paths';

const InitialSetup = ({ children }) => {
  loadEnvironmentUrls();
  useLanguageList();
  useLanguageMonitor();
  return children;
};

export default InitialSetup;
